import React from "react";
import { Wrapper, FormContainer, HeaderContainer } from "./styled";
import Header from "./components/Header";
import Form from "./components/Form";

const StartForm = () => {
  return (
    <Wrapper>
      <HeaderContainer>
        <Header />
      </HeaderContainer>
      <FormContainer>
        <Form />
      </FormContainer>
    </Wrapper>
  );
};

export default StartForm;
